export default {"src":"/_next/static/media/PlayStoreIconOnly.0c229579.svg","height":24,"width":22};